import React, { useEffect, useState,useRef } from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Logo from "../../assets/normLogo.png";
import Form from "react-bootstrap/Form";
import CloseButton from "react-bootstrap/esm/CloseButton";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import Loader from '../../elements/Loader';
import {BuyerNumberUpdate,hideBuyerNumberModal,showBuyerNumberModal,showEditBuyerNumberModal,hideEditBuyerNumberModal,getBuyerNumbers,BuyerNumberEdit,inputHandler,registerBuyerNumber, BuyerNumberDelete } from "../../../redux/actions";

function BuyerNumbers(props) {


// const [addBuyerNumberData,setAddBuyerNumberData] = useState({name:''});
const [BuyerNumberData,setBuyerNumberData] = useState({name:'',onId:''});
const [checkedState, setCheckedState] = useState([]);
const checkBoxRef = useRef([]);


  useEffect(() => {
    props.getBuyerNumbers(props.currentPage);
  }, [props.registerBuyerNumberSuccess,props.updateSuccess,props.deleteSuccess]);


useEffect(()=>{
setBuyerNumberData({...BuyerNumberData,'name':props.editDetails?.data?.buyer_no||''})
},[props.editDetails])



  //   useEffect(()=>{

  //     setRoleNameEdit({name:props.showPermissions?.role.name?props.showPermissions?.role.name:''});
    
     
  
  
  // },[props.showPermissions] )



  const onInputchange = (e) => {
    props.inputHandler({ key: e.target.name, value: e.target.value });
    // setRoleData({ ...roleData, [e.target.name]: e.target.value });
  };





  const onInputUpdatechange = (e) => {
    // props.inputHandler({ key: e.target.name, value: e.target.value });
    setBuyerNumberData({...BuyerNumberData, name:e.target.value  });
  };

// ============================================
//  to rigister role modal
// ============================================
  const handleClose = () => {
  
    props.hideBuyerNumberModal()

  };
  const handleShow = () => {

    props.showBuyerNumberModal()
  
  };

// ============================================
// to register edit modal open and close
// ============================================

  const handleEditClose = () => {
    props.hideEditBuyerNumberModal();

  };

  const handleEditShow=()=>{
    props.showEditBuyerNumberModal()

  }




const deleteBuyerNumber = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this BuyerNumber",
    icon: "warning",
    width: 400,
    showCancelButton: true,
    timer: 4000,
    timerProgressBar: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      props.BuyerNumberDelete(id, props.currentPage);
    }
  });
};





const submitBuyerNumber = (e) => {
  e.preventDefault();
  let name=props?.name;
  if(name){
    props.registerBuyerNumber(name)
  }
}


const UpdateBuyerNumber = (e) => {
  e.preventDefault();
  let name=BuyerNumberData.name;
  let id=BuyerNumberData.onId;
  let currentPage=props.BuyerNumbersList?.data?.current_page;
  props.BuyerNumberUpdate(id,name,currentPage);
  
}




  return (
    <>
      

      <div className="container-Layer">
      <Link to="/home/settings" className="back-button-outer">

    <center> <i className="fa fa-arrow-left" style={{color:'white'}}></i> </center> 
      </Link>

      <div className="row">
      <div className="col-md-7">   
      <div className="addButton"><a onClick={handleShow} className="btn btn-primary">Add Buyer Number</a></div>
      </div>
      <div className="col-md-5">

      </div>

     
        </div>

        <div className="row text-center pt-4">
          {props.loading ? 
            <Loader
              width={"40px"}
              height={"40px"}
              iconColor={"white"}
              backgroundColor={"#deb726"}
              left={"0%"}
              top={"30%"}
            />
          :
            props.BuyerNumbersList?.data?.data.map((list, index) => {
              return (
                <div
                  className="col-xl-3 col-sm-4 col-md-3 mb-5 card-outer"
                  key={index}
                >
                
            <div
              className="shadow-sm py-2 px-4 settings-list-card "
              style={{ borderLeft: "5px solid #fcba03" }}
            >
              <p className="mt-2 text-uppercase">{list.buyer_no}</p>
              {/* <span className="small text-uppercase text-muted">Admin</span> */}
              <ul className="social mb-0 list-inline mt-3">
                
                <li className="list-inline-item settings-links">
                  <a  onClick={
                    ()=>{
                      setBuyerNumberData({...BuyerNumberData,'onId':list.id})
                      props.BuyerNumberEdit(list.id)
                      setTimeout(()=>{
                        handleEditShow()

                      },190)

                    }} className="icons-link">
                    <i className="fa fa-edit edit"></i>
                  </a>
                </li>
                <li className="list-inline-item settings-links">
                  <a  onClick={()=>deleteBuyerNumber(list.id)} className="icons-link">
                    <i className="fa fa-trash trash"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
              );
            })}

          
            {props.BuyerNumbersList && (
        <div className="row">
          <div className="paginate col-md-6">
            <Pagination
              activePage={props.BuyerNumbersList?.data?.current_page}
              itemsCountPerPage={props.BuyerNumbersList?.data?.per_page}
              totalItemsCount={props.BuyerNumbersList?.data.total}
              //   pageRangeDisplayed={5}
              onChange={(pageNumber) => props.getBuyerNumbers(pageNumber)}
              itemClass="page-item"
              linkClass="page-link"
              lastPageText="Last"
              firstPageText="First"
            />
          </div>
        </div>
      )}



        </div>
      </div>


{/* ======================
Add Role Modal
====================== */}
      <Modal show={props.showWarModal} onHide={handleClose} size="md" >
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Add New Buyer Number </Modal.Title>
          <CloseButton variant={"white"} onClick={handleClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={submitBuyerNumber}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="Buyer Number">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="name"
                    value={props?.name}
                    required
                    onChange={(e) => onInputchange(e)}
                    isInvalid={props.BuyerNumberRegisterErrors?.error?.buyer_no?true:false}
                  />

                </FloatingLabel>

                {props.BuyerNumberRegisterErrors?.error?.buyer_no ? (
                  <div className="validation-error">
                    The buyer number already exists !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
   
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Add
            </button>
          </Modal.Footer>
        </form>
      </Modal>











{/* ======================
Edit Role Modal
====================== */}
<Modal show={props.showEditWarModal} onHide={handleEditClose} size="md" >
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Edit Buyer Number </Modal.Title>
          <CloseButton variant={"white"} onClick={handleEditClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={UpdateBuyerNumber}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="Buyer Number">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="editBuyerNumberName"
                    value={BuyerNumberData.name||''}
                    required
                    onChange={(e) => onInputUpdatechange(e)}
                    isInvalid={props.BuyerNumberUpdateErrors?.error?.buyer_no ?true:false}
                  />

                </FloatingLabel>

                {props.BuyerNumberUpdateErrors?.error?.buyer_no ? (
                  <div className="validation-error">
                    The buyer number name already exists, you can't update it with this BuyerNumber name !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
    
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Done
            </button>
          </Modal.Footer>
        </form>
      </Modal>








    </>
  );
}

const mapStateToProps = (state) => {
  const {loading,BuyerNumbersList,showWarModal,showEditWarModal,name,registerBuyerNumberSuccess,BuyerNumberRegisterErrors,currentPage,editDetails,updateSuccess,deleteSuccess,BuyerNumberUpdateErrors} = state.SettingsBuyerNumberHandler;

  return {
    loading: loading,
    name:name,
    BuyerNumberRegisterErrors:BuyerNumberRegisterErrors,
    currentPage:currentPage,
    BuyerNumbersList:BuyerNumbersList,
    showWarModal:showWarModal,
    showEditWarModal:showEditWarModal,
    registerBuyerNumberSuccess:registerBuyerNumberSuccess,
    editDetails:editDetails,
    updateSuccess:updateSuccess,
    deleteSuccess:deleteSuccess,
    BuyerNumberUpdateErrors:BuyerNumberUpdateErrors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {


     inputHandler: ({ key, value }) => dispatch(inputHandler({ key, value })),
      getBuyerNumbers:(currentPage)=>dispatch(getBuyerNumbers(currentPage)),
      showBuyerNumberModal:()=>dispatch(showBuyerNumberModal()),
      hideBuyerNumberModal:()=>dispatch(hideBuyerNumberModal()),
      showEditBuyerNumberModal:()=>dispatch(showEditBuyerNumberModal()),
      hideEditBuyerNumberModal:()=>dispatch(hideEditBuyerNumberModal()),
      registerBuyerNumber:(name)=>dispatch(registerBuyerNumber(name)),
      BuyerNumberEdit:(id)=>dispatch(BuyerNumberEdit(id)),
      BuyerNumberUpdate:(id,name,currentPage)=>dispatch(BuyerNumberUpdate(id,name,currentPage)),
      BuyerNumberDelete:(id,currentPage)=>dispatch(BuyerNumberDelete(id,currentPage)),
  };


};

export default connect(mapStateToProps, mapDispatchToProps)(BuyerNumbers);



// =============================
// design version: 1.0
// design by sabaoon bedar
// =============================